import { faUserCircle } from "@fortawesome/free-solid-svg-icons/faUserCircle";
import React from "react";

import { User } from "../model/user/User";
import { getMediaUrl } from "../utils/Media";
import { Avatar } from "../utils/local-antd";
import { AtiraIcon } from "./AtiraIcon";

type MemberAvatarProps = {
  member?: Partial<Pick<User, "name" | "picture">>;
  size?: number;
};

export const MemberAvatar: React.FC<MemberAvatarProps> = ({
  member,
  size = 20,
}) => {
  if (!member?.picture) {
    return (
      <Avatar
        size={size}
        alt={member?.name}
        icon={<AtiraIcon icon={faUserCircle} color="main" />}
        style={{ background: "transparent", flexShrink: 0 }}
      />
    );
  }

  const isGoogleImageURL = member.picture.startsWith(
    "https://lh3.googleusercontent.com/",
  );

  return (
    <Avatar
      size={size}
      alt={member.name}
      src={isGoogleImageURL ? member.picture : getMediaUrl(member.picture)}
      style={{ flexShrink: 0 }}
    />
  );
};
